import { render, staticRenderFns } from "./CreateGiro.vue?vue&type=template&id=2fbe4c38"
import script from "./CreateGiro.vue?vue&type=script&lang=js"
export * from "./CreateGiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports